import signIn from "../assets/icons/fa_sign_in.png";
import { isInIframe } from 'serenova-js-utils/browser';

export const detailHeaderText = (itemArray, name) => {
  if (itemArray) {
    return `${itemArray.length > 1 ? itemArray.length : ''} ${name}`;
  } else {
    return name;
  }
};

let pathUrl = document.referrer;
if (!pathUrl) {
  /**this check is for PR generated links with specific url
   * also when qe & staging accessed within iframe **/
  pathUrl = window.location.origin.includes('frontend-prs') ? (window.location.origin + window.location.pathname) : 
            (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0 ? window.location.ancestorOrigins[0] : window.location.origin) + '/'
}

//for FF only if ancestorOrigins property not woking then to handle for qe..
if (!isInIframe() && pathUrl.includes("config2")) {
  pathUrl = pathUrl.replace("config2", "config");
}

export const parentUrl = pathUrl;

const cloneObject = obj => Object.assign({}, obj);

export const renameObjectKey = (object, key, newKey) => {
  const clonedObj = cloneObject(object);
  const targetKey = clonedObj[key];
  delete clonedObj[key];
  clonedObj[newKey] = targetKey;
  return clonedObj;
};

// Sort method to sort strings in entity tables
export const customSortStringMethod = (a, b) => {
  let tempArray = [];
  tempArray = [a, b];

  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
  tempArray.sort(collator.compare);

  if (tempArray[0] === a) {
    return -1;
  } else {
    return 1;
  }
};

export const setTenantOptionStyle = (sso, currentTenant, availableTenants, accountTenants) => {
  const styles = {
    reAuthOption: {
      backgroundColor: '#ddd',
      backgroundImage: `url(${signIn})`,
      backgroundPosition: '5%',
      paddingLeft: '33px',
      marginLeft: '2%',
      borderBottom: '1px solid #000',
    },
  };
  if (accountTenants.length && requiresReAuth(sso, currentTenant, availableTenants, accountTenants)) {
    return styles.reAuthOption;
  }
  return undefined;
};

export const requiresReAuth = (sso, currentTenant, availableTenants, accountTenants) => {
  // if it is SSO
  if (sso && accountTenants) {
    // make sure that this is one of the active tenants
    const tenant = accountTenants.find(
      (tenant) => tenant.tenantId === currentTenant.tenantId
    );
    if (tenant) {
      let tenantActiveBool;
      if (typeof tenant.tenantActive !== 'boolean') {
        // if we are searching through the accountTenants
        // array (as opposed to the tenants array), then we won't have
        // the tenantActive boolean property we need - so grab it!
        const accountTenant = accountTenants.find(
          (tenant) => tenant.tenantId === tenant.tenantId
        );
        tenantActiveBool = accountTenant.active;
      } else {
        tenantActiveBool = tenant.tenantActive;
      }

      // if this is an active tenant, then no need to reauthenticate
      if (tenantActiveBool) {
        return false;
      }

      return true;
    } else {
      return true;
    }
  } else if (availableTenants) {
    // if it's not SSO, then make sure that there is a password associated
    // with both the selected tenant AND the one you're trying to navigate to
    const targetTenant = availableTenants.find(
      (tenantObj) => tenantObj.tenantId === currentTenant.tenantId
    );
    return !(
      targetTenant &&
      !!targetTenant.password &&
      !sso
    );
  }
};

export const nonceToStyles = () => {
  const stylesTags = document.querySelectorAll('style');

  stylesTags.forEach((tag) => {
    if (!tag.nonce) {
      tag.setAttribute('nonce', window.__cspNonce);
    }
  });
}

export const nonceToScripts = () => {
  const scriptTags = document.querySelectorAll('script');

  scriptTags.forEach((tag) => {
    if (!tag.nonce) {
      tag.setAttribute('nonce', window.__cspNonce);
    }
  });
}
